import styles from "./analytics-table.module.css"

export default function ProductPerformanceTable({ products }) {
  return (
    <div className={styles.tableContainer}>
      <h2>Product Performance</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Product</th>
              <th>Provider</th>
              <th>Orders</th>
              <th>Revenue</th>
              <th>Profit</th>
              <th>Margin</th>
              <th>Success Rate</th>
            </tr>
          </thead>
          <tbody>
            {products?.map((product, index) => (
              <tr key={index}>
                <td>{product._id.name}</td>
                <td>{product._id.provider}</td>
                <td>{product.totalOrders}</td>
                <td>₹{product.totalRevenue.toLocaleString()}</td>
                <td>₹{product.totalProfit.toLocaleString()}</td>
                <td>{product.profitMargin}%</td>
                <td>
                  <span className={product.successRate >= 95 ? styles.success : styles.warning}>
                    {product.successRate}%
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
